import script from "./DeviceDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./DeviceDetail.vue?vue&type=script&setup=true&lang=js"

import "./DeviceDetail.vue?vue&type=style&index=0&id=7c952218&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c952218"]])

export default __exports__